import { render, staticRenderFns } from "./OffRiskApproval.vue?vue&type=template&id=4d85e0cc&scoped=true"
import script from "./OffRiskApproval.vue?vue&type=script&lang=js"
export * from "./OffRiskApproval.vue?vue&type=script&lang=js"
import style0 from "./OffRiskApproval.vue?vue&type=style&index=0&id=4d85e0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85e0cc",
  null
  
)

export default component.exports